// Copyright (c) 2022 by Move Closer

import { ClassRegistry } from '../../composables/use-class-registry'

import { CardDirection } from './Card.contracts'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const variantsDirectionRegistry: ClassRegistry<string> = {
  [CardDirection.Default]: '',
  [CardDirection.Row]: '--row'
}
